// extracted by mini-css-extract-plugin
export default {"updateCheckPage":"UpdateCheckPage_updateCheckPage__Ut07M"};